/* eslint-disable @typescript-eslint/naming-convention */

/**
 * Fluent UI color palette.
 * {@docCategory IPalette}
 */
export interface IPalette {
  /**
   * Color code for themeDarker.
   */
  themeDarker: string;

  /**
   * Color code for themeDark.
   */
  themeDark: string;

  /**
   * Color code for themeDarkAlt.
   */
  themeDarkAlt: string;

  /**
   * Color code for themePrimary.
   */
  themePrimary: string;

  /**
   * Color code for themeSecondary.
   */
  themeSecondary: string;

  /**
   * Color code for themeTertiary.
   */
  themeTertiary: string;

  /**
   * Color code for themeLight.
   */
  themeLight: string;

  /**
   * Color code for themeLighter.
   */
  themeLighter: string;

  /**
   * Color code for themeLighterAlt.
   */
  themeLighterAlt: string;

  /**
   * Color code for the strongest color, which is black in the default theme.
   * This is a very light color in inverted themes.
   */
  black: string;

  /**
   * Color code for blackTranslucent40.
   */
  blackTranslucent40: string;

  /**
   * Color code for neutralDark.
   */
  neutralDark: string;

  /**
   * Color code for neutralPrimary.
   */
  neutralPrimary: string;

  /**
   * Color code for neutralPrimaryAlt.
   */
  neutralPrimaryAlt: string;

  /**
   * Color code for neutralSecondary.
   */
  neutralSecondary: string;

  /**
   * Color code for neutralSecondaryAlt.
   */
  neutralSecondaryAlt: string;

  /**
   * Color code for neutralTertiary.
   */
  neutralTertiary: string;

  /**
   * Color code for neutralTertiaryAlt.
   */
  neutralTertiaryAlt: string;

  /**
   * Color code for neutralQuaternary.
   */
  neutralQuaternary: string;

  /**
   * Color code for neutralQuaternaryAlt.
   */
  neutralQuaternaryAlt: string;

  /**
   * Color code for neutralLight.
   */
  neutralLight: string;

  /**
   * Color code for neutralLighter.
   */
  neutralLighter: string;

  /**
   * Color code for neutralLighterAlt.
   */
  neutralLighterAlt: string;

  /**
   * Color code for the accent.
   */
  accent: string;

  /**
   * Color code for the softest color, which is white in the default theme. This is a very dark color in dark themes.
   * This is the page background.
   */
  white: string;

  /**
   * Color code for whiteTranslucent40
   */
  whiteTranslucent40: string;

  /**
   * Color code for yellowDark.
   */
  yellowDark: string;

  /**
   * Color code for yellow.
   */
  yellow: string;

  /**
   * Color code for yellowLight.
   */
  yellowLight: string;

  /**
   * Color code for orange.
   */
  orange: string;

  /**
   * Color code for orangeLight.
   */
  orangeLight: string;

  /**
   * Color code for orangeLighter.
   */
  orangeLighter: string;

  /**
   * Color code for redDark.
   */
  redDark: string;

  /**
   * Color code for red.
   */
  red: string;

  /**
   * Color code for magentaDark.
   */
  magentaDark: string;

  /**
   * Color code for magenta.
   */
  magenta: string;

  /**
   * Color code for magentaLight.
   */
  magentaLight: string;

  /**
   * Color code for purpleDark.
   */
  purpleDark: string;

  /**
   * Color code for purple.
   */
  purple: string;

  /**
   * Color code for purpleLight.
   */
  purpleLight: string;

  /**
   * Color code for blueDark.
   */
  blueDark: string;

  /**
   * Color code for blueMid.
   */
  blueMid: string;

  /**
   * Color code for blue.
   */
  blue: string;

  /**
   * Color code for blueLight.
   */
  blueLight: string;

  /**
   * Color code for tealDark.
   */
  tealDark: string;

  /**
   * Color code for teal.
   */
  teal: string;

  /**
   * Color code for tealLight.
   */
  tealLight: string;

  /**
   * Color code for greenDark.
   */
  greenDark: string;

  /**
   * Color code for green.
   */
  green: string;

  /**
   * Color code for greenLight.
   */
  greenLight: string;
}
